import { API_ENDPOINTS } from '@tsgecart/config';
import { adminApiFetch } from '../../api/admin-client.js';
import type {
  AdminCustomerSummary,
  AdminCustomerProfile,
  CustomerListParams,
  UpdateCustomerStatusInput,
  UpdateCustomerStatusResult,
} from '../types/customers.js';

export interface FetchOptions {
  token: string;
  signal?: AbortSignal;
}

function buildQuery(params: Record<string, string | number | boolean | string[] | undefined>): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined) continue;
    search.set(key, Array.isArray(value) ? value.join(',') : String(value));
  }
  const query = search.toString();
  return query ? `?${query}` : '';
}

export async function fetchAdminCustomers(
  params: CustomerListParams,
  options: FetchOptions,
): Promise<AdminCustomerSummary[]> {
  const query = buildQuery({
    search: params.search,
    status: params.status,
    registeredFrom: params.registeredFrom,
    registeredTo: params.registeredTo,
    sortField: params.sortField,
    sortDirection: params.sortDirection,
    limit: params.limit,
    offset: params.offset,
  });
  return adminApiFetch<AdminCustomerSummary[]>(`${API_ENDPOINTS.adminCustomers}${query}`, options);
}

export async function fetchAdminCustomerProfile(
  customerId: string,
  options: FetchOptions,
): Promise<AdminCustomerProfile> {
  return adminApiFetch<AdminCustomerProfile>(`${API_ENDPOINTS.adminCustomers}/${customerId}`, options);
}

export async function updateAdminCustomerStatus(
  customerId: string,
  input: UpdateCustomerStatusInput,
  options: FetchOptions,
): Promise<UpdateCustomerStatusResult> {
  return adminApiFetch<UpdateCustomerStatusResult>(`${API_ENDPOINTS.adminCustomers}/${customerId}/status`, {
    ...options,
    method: 'POST',
    body: input,
  });
}
